<template>
<div class="chapter">
<div class="inner_page">
<h1 class="chaptitle2"><a id="page_vii"></a><a id="cont"></a>CONTENTS</h1>
<p class="toc"><a href="#/07_acknowledgments#ack"><b>ACKNOWLEDGMENTS</b></a></p>
<p class="toc"><a href="#/08_foreword#fore"><b>FOREWORD</b></a></p>
<p class="toc"><a href="#/09_introduction#intro"><b>INTRODUCTION:</b> A Systems Approach</a></p>
<p style="text-align:center; margin-top:1.5pc"></p>
<p class="toc"><a href="#/10_chapter01#c01"><b>CHAPTER 1:</b> Accountability</a></p>
<p class="toc"><span href="#/11_chapter02#c02" title="Link target outside of Sample"><b>CHAPTER 2:</b> L.E.A.D</span></p>
<p class="toc"><span href="#/12_chapter03#c03" title="Link target outside of Sample"><b>CHAPTER 3:</b> Work, Complexity, and Levels</span></p>
<p class="toc"><span href="#/13_chapter04#c04" title="Link target outside of Sample"><b>CHAPTER 4:</b> Capabilities, Potential, and Effectiveness</span></p>
<p class="toc"><span href="#/14_chapter05#c05" title="Link target outside of Sample"><b>CHAPTER 5:</b> Principles of Organization Design: How the Multipliers Are Integrated</span></p>
<p class="toc"><span href="#/15_chapter06#c06" title="Link target outside of Sample"><b>CHAPTER 6:</b> Accountability and Types of Teams</span></p>
<p class="toc"><span href="#/16_chapter07#c07" title="Link target outside of Sample"><b>CHAPTER 7:</b> Functions and Functional Alignment</span></p>
<p class="toc"><span href="#/17_chapter08#c08" title="Link target outside of Sample"><b>CHAPTER 8:</b> Structuring Accountable Cross-Functional Processes</span></p>
<p class="toc"><span href="#/18_chapter09#c09" title="Link target outside of Sample"><b>CHAPTER 9:</b> System Stewardship: How to Defeat Matrix Management</span></p>
<p class="toc"><span href="#/19_chapter10#c10" title="Link target outside of Sample"><b>CHAPTER 10:</b> Human Resource Systems</span></p>
<p class="toc"><span href="#/20_chapter11#c11" title="Link target outside of Sample"><b>CHAPTER 11:</b> Implementing a Strategic Organization</span></p>
<p class="toc"><span href="#/21_chapter12#c12" title="Link target outside of Sample"><b>CHAPTER 12:</b> Leadership in Healthcare Systems</span></p>
<p class="toc"><span href="#/22_chapter13#c13" title="Link target outside of Sample"><b>CHAPTER 13:</b> Anatomy of a Leader</span></p>
<p class="toc"><span href="#/23_chapter14#c14" title="Link target outside of Sample"><b>CHAPTER 14:</b> Sustainability: The Purpose-Driven Organization</span></p>
<p style="text-align:center; margin-top:.5pc"></p>
<p class="toc"><span href="#/24_notes#note" title="Link target outside of Sample"><b>NOTES</b></span></p>
<p class="toc"><span href="#/25_index#index" title="Link target outside of Sample"><b>INDEX</b></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 05_contents.vue?a13b7dd0